import $ from 'jquery';
import AOS from 'aos';

/* Animate on scroll */

$(document).ready(function () {
    /* Animations */
    $(".aos-fade-up").each(function () {
        $(this).attr('data-aos','fade-up');
    });

    $(".aos-fade-down").each(function () {
        $(this).attr('data-aos','fade-down');
    });

    $(".aos-fade-right").each(function () {
        $(this).attr('data-aos','fade-right');
    });

    $(".aos-fade-left").each(function () {
        $(this).attr('data-aos','fade-left');
    });

    $(".aos-fade-up-right").each(function () {
        $(this).attr('data-aos','fade-up-right');
    });

    $(".aos-fade-up-left").each(function () {
        $(this).attr('data-aos','fade-up-left');
    });

    $(".aos-zoom-in").each(function () {
        $(this).attr('data-aos','zoom-in');
    });

    $(".aos-flip-up").each(function () {
        $(this).attr('data-aos','flip-up');
    });

    $(".aos-flip-left").each(function () {
        $(this).attr('data-aos','flip-left');
    });

    $(".aos-flip-right").each(function () {
        $(this).attr('data-aos','flip-right');
    });

    $(".aos-zoom-in").each(function () {
        $(this).attr('data-aos','zoom-in');
    });

    $(".aos-zoom-out").each(function () {
        $(this).attr('data-aos','zoom-out');
    });

    $(".aos-zoom-in-left").each(function () {
        $(this).attr('data-aos','zoom-in-left');
    });

    $(".aos-zoom-in-right").each(function () {
        $(this).attr('data-aos','zoom-in-right');
    });

    /* Options */
    $(".aos-easing").each(function () {
        $(this).attr('data-aos-easing','ease-in-sine');
    });

    AOS.init({
      once: true,
      throttleDelay: -75,
      duration: 650,
    });
});

//Fix delay
$(window).on('load', function() {
  AOS.refresh();
});
